import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getWrappedValueWithLink } from '../../../../helpers';
import { parseBooleanValues } from '../../helpers';
import { withTitle } from '../../../../HOC';

const TextSummaryContent = ({ summaryPropsWithContent }) => {
  const { itemId } = useContext(MainContext);

  return (
    <div className="stats__heading">
      {summaryPropsWithContent.map(([key, value, link, modifier], index) => {
        const wrappedValue = parseBooleanValues(getWrappedValueWithLink(value, link, itemId), key);
        const dynamicKey = [itemId, index].join('-');

        if (!wrappedValue) return null;

        return (
          <span className={modifier} key={dynamicKey}>
            {wrappedValue}
          </span>
        );
      })}
    </div>
  );
};

TextSummaryContent.propTypes = {
  summaryPropsWithContent: PropTypes.array.isRequired
};

export default withTitle(TextSummaryContent);
